/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './instruments';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankc": {
        "nested": {
          "ExternalListBalanceInstrumentsRequest": {
            "fields": {
              "unitToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "instrumentType": {
                "type": ".squareup.bankc.BalanceInstrumentType",
                "id": 2,
                "rule": "optional"
              },
              "password": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "ExternalListBalanceInstrumentsResponse": {
            "fields": {
              "balanceInstrument": {
                "type": ".squareup.bankc.BalanceInstrument",
                "id": 1,
                "rule": "repeated"
              },
              "error": {
                "type": ".squareup.bankc.ExternalListBalanceInstrumentsResponse.Error",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Error": {
                "values": {
                  "DO_NO_USE": 0,
                  "INVALID_PASSWORD": 1,
                  "UNAUTHORIZED": 2
                }
              }
            }
          },
          "ExternalBalanceProxyService": {
            "methods": {
              "ListBalanceInstruments": {
                "requestType": ".squareup.bankc.ExternalListBalanceInstrumentsRequest",
                "responseType": ".squareup.bankc.ExternalListBalanceInstrumentsResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankc?.nested?.ExternalListBalanceInstrumentsRequest && !$root.nested?.squareup?.nested?.bankc?.nested?.ExternalListBalanceInstrumentsResponse && !$root.nested?.squareup?.nested?.bankc?.nested?.ExternalListBalanceInstrumentsResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bankc?.nested?.ExternalBalanceProxyService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ExternalListBalanceInstrumentsRequest @ squareup/bankc/service.proto at 277:1
 */
export const ExternalListBalanceInstrumentsRequest = $root.lookupType('squareup.bankc.ExternalListBalanceInstrumentsRequest');
fixType(ExternalListBalanceInstrumentsRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ExternalListBalanceInstrumentsRequest);
/**
 * SOURCE ExternalListBalanceInstrumentsResponse @ squareup/bankc/service.proto at 297:1
 */
export const ExternalListBalanceInstrumentsResponse = $root.lookupType('squareup.bankc.ExternalListBalanceInstrumentsResponse');
fixType(ExternalListBalanceInstrumentsResponse);
Builder.createAndAttachToType(ExternalListBalanceInstrumentsResponse);
/**
 * SOURCE Error @ squareup/bankc/service.proto at 298:3
 */
ExternalListBalanceInstrumentsResponse.Error = $root.lookupEnum('squareup.bankc.ExternalListBalanceInstrumentsResponse.Error').values;
/**
 * SOURCE ExternalBalanceProxyService @ squareup/bankc/service.proto at 804:1
 */
export const ExternalBalanceProxyService = $root.lookupService('squareup.bankc.ExternalBalanceProxyService');